import React from 'react';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {PATH_GAMES, PATH_GAMES_HANGEDMAN_INSTANCE} from "app/routes";
import generatePathname from "core/helpers/generatePathname";
import createInstance from 'app/games/hangedman/actions/createInstance';
import GameTitle from 'app/games/hangedman/gameTitle';
import Desktop from 'app/desktop';
import 'app/games/hangedman/createInstance.css';

export default function CreateInstance() {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  const handleSubmit = async () => {
    const createdInstance = await dispatch(createInstance());
    history.push(generatePathname(PATH_GAMES_HANGEDMAN_INSTANCE, { instanceId: createdInstance.id }));
  };

  return (
    <Desktop title={t('games.title')}>
      <div className="HangedmanCreateInstance">
        <GameTitle />
        <div className="HangedmanCreateInstanceButtons panel padded">
          <button className="HangedmanCreateInstanceSubmit button primary xlarge" onClick={handleSubmit}>
            {t('games.hangedman.newInstance.submit')}
          </button>
          <Link to={PATH_GAMES} className="HangedmanCreateInstanceBack BackToGames button secondary">
            {t('games.backToGames')}
          </Link>
        </div>
      </div>
    </Desktop>
  );
}
